module.exports = {
  mmzs: '注：由於追溯系統手持PAD密碼不支持全部特殊字元，在重置追溯系統帳號密碼時，特殊字元僅能使用#或@',
  mqzwdbcl: '目前暫無待辦處理哦！',
  cxyzzjjkfz: '程序猿正在緊急開發中，請稍安勿躁！',
  yhtymh: '頤海統一門戶',
  thtymhqxqbxt: '頤海統一門戶旗下所有系統',
  ghbj: '更換背景',
  hymr: '還原默認',
  ckgd: '查看更多',
  qd: '確定',
  qr: '確認',
  qx: '取消',
  tc: '退出',
  czcg: '操作成功',
  wxts: '溫馨提示',
  // 登录页
  loginPage: {
    qhqyzm: '請獲取驗證碼',
    tysfglpt: '統一門戶系統',
    zhdl: '賬號登錄',
    yhmygbh: '用戶名/員工編號',
    sjhm: '手機號碼',
    xgmm: '修改密碼',
    mm: '密碼',
    qxgcsmm: '請修改初始密碼',
    mmydqqxgmm: '密碼已到期，請修改密碼',
    xmmbnyjmmxt: '新密碼不能與舊密碼相同',
    xmm: '新密碼',
    ymm: '原密碼',
    qrxmm: '確認新密碼',
    wjmm: '忘記密碼',
    xyhddl: '向右滑動登錄',
    yzcg: '驗證成功',
    smdl: '掃碼登錄',
    qywxsm: '企業微信掃碼',
    ddsm: '釘釘掃碼',
    fssm: '飛書掃碼',
    ewmysx: '二維碼已失效',
    sxewm: '刷新二維碼',
    dxyzm: '短信驗證碼',
    hqyzm: '獲取驗證碼',
    xyb: '下一步',
    dlsjyz: '登錄手機驗證',
    wbll: '外部鏈接',
    bq: '版權',
    mmbyz: '密碼不一致',
    hcxhq: '後重新獲取',
    qxsrzqdsjhm: '請先輸入正確的手機號碼',
    qsrdxyzm: '請輸入短信驗證碼',
    qsryhm: '請輸入用戶名',
    qxzsjhm: '請選擇手機號碼',
    fscg: '發送成功',
    yhmbnwk: '用戶名不能為空',
    yhmwgzf: '用戶名為3-12個字符',
    yhmbnczkg: '用戶名/員工編號不能存在空格',
    mmbnwk: '密碼不能為空',
    ymmbnwk: '原密碼不能為空',
    mmwsfzhlw: '密碼為身分證後6位',
    mmzswzmsztszf: '密碼至少為8位字母、數字、特殊字符組合',
    mmzswzmsztszfnew: '密碼至少為8位字母、數字、特殊字符組合，特殊字符僅能使用#或者@'
  },
  // 首页
  homePage: {
    ty: '泰語',
    hy: '韓語',
    gh: '工號',
    zh: '賬號',
    gw: '崗位',
    sj: '手機',
    yx: '郵箱',
    yy: '語言',
    pf: '皮膚',
    bj: '背景',
    yh: '代理',
    xtyyxz: '系統語言選擇',
    zwjt: '中文簡體',
    zwft: '中文繁體',
    yw: '英文',
    qb: '全部',
    wdyy: '我的應用',
    dlbjxgqh: '登錄背景效果切換',
    zjbj: '中間背景',
    ybbj: '右邊背景',
    qhdlr: '切換代理人',
    xtpfqh: '系統皮膚切換'
  }
}
